import { useEffect, useState } from "react";

import styled from "styled-components";
import ApiController from "../../controller/ApiController";
import {
  CategoryType,
  storeDetailType,
  storeType,
} from "../../controller/StoreController";
import MenuInfo from "./menuInfo";

import { useParams } from "react-router-dom";
import { getRecoil } from "recoil-nexus";
import { authState } from "../../recoil/auth";

const StorePreview = () => {
  const { store_id } = useParams();
  const [storeInfo, setStoreInfo] = useState<storeType>();

  const [storeDetailInfo, setStoreDetailInfo] = useState<storeDetailType[]>([]);
  const [storeId, setStoreId] = useState<number>(0);
  const [menuInfo, setMenuInfo] = useState<CategoryType[]>([]);
  const [isCheckAdult, setIsCheckAdult] = useState<boolean>(false);

  //매장정보, 메뉴정보 가져오기
  const getStoreData = async (store_id: number) => {
    console.log("auth", getRecoil(authState));
    try {
      const res = await ApiController.store.getKnockStoreData({
        store_id,
        parent_store_id: getRecoil(authState).store_list.filter(
          (a: any) => a.store_type === 2
        )[0].store_id,
        user_token_id: getRecoil(authState).user_token_id,
        user_id: getRecoil(authState).user_id,
      });
      setStoreInfo(res?.data.data.store);
      setMenuInfo(res?.data.data.menu);
      setStoreDetailInfo(res?.data.data.detail);
      // }
    } catch (err) {
      console.log("fff");
      console.log("getStoreData err-->", err);
    }
  };

  useEffect(() => {
    console.log("master");
    if (store_id !== undefined) {
      setStoreId(parseInt(store_id));
      getStoreData(parseInt(store_id));
    }
  }, []);

  return (
    <>
      <Style>
        <div className="wrap">
          <div className="container">
            <div className="header">
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_home.svg`}
                alt="뒤로가기"
              />
            </div>
            {/* eventSlider */}
            <div className="slideWrap"></div>
            {storeInfo && (
              <>
                <div className="menuWrap">
                  <MenuInfo
                    storeId={storeId}
                    menuInfo={menuInfo}
                    storeInfo={storeInfo}
                    storeDetailInfo={storeDetailInfo}
                    zoom={false}
                    isCheckAdult={isCheckAdult}
                    setIsCheckAdult={setIsCheckAdult}
                    resetTimer={() => {}}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </Style>
    </>
  );
};
export default StorePreview;

const Style = styled.div`
  .container {
    width: 100%;
    max-width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
  }

  .header {
    height: auto;
    max-height: 11vh;
    padding-top: 20px;
    margin: 0 4%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .storeName {
      font-size: 32px;
      font-weight: 300;
    }
  }
  .slideWrap {
    display: flex;
    align-items: center;
    max-width: 100%;
    min-height: 5vh;
    gap: 50%;
  }

  .slideBadge {
    padding: 0 20px;
    margin: 18px 0;
    background: #40977f;
    border-radius: 50px;
    animation: slideIn 15s linear infinite;
    display: inline-flex;
    align-items: center;

    p {
      font-size: 16px;
      line-height: 30px;
      font-weight: 300;
      color: #ffffff;
      white-space: nowrap;
    }
  }
  .slideBadge.time {
    background: #ffba07;
  }

  @keyframes slideIn {
    0% {
      transform: translateX(110vw);
    }

    100% {
      transform: translateX(-140vw);
    }
  }

  // 매장 선택 화면
  .slider {
    width: 420px;
    .arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
    }
    .arrow.left {
      left: -50px;
    }
    .arrow.right {
      right: -50px;
    }
  }
  .storeItem {
    margin: 0 2px;
    max-width: 80px;
    display: flex;
    flex-direction: column;

    img {
      width: 100%;
      height: 70px;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      object-fit: cover;
      filter: brightness(50%);
    }
    img.active {
      filter: brightness(100%);
    }
    .storeTitle {
      width: 100%;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #5e5e5e;
      padding: 0 6px;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;

      p {
        color: #ffffff;
        font-size: 14px;
        line-height: 25px;
        font-weight: 300;
        margin: 0 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  /* 메뉴 */
  .menuWrap {
    height: 100%;
    overflow: auto;
  }

  /* 장바구니 */
  .cartWrap {
    height: 100%;
    max-height: 26vh;
    z-index: 999;
  }
`;
